import type { HTMLAttributes, ReactNode } from 'react';

interface Props extends HTMLAttributes<HTMLDivElement> {
  titolo?: ReactNode;
  /** Azione o dato allineato a destra del titolo. */
  accanto?: ReactNode;
  /** Filetto marcato invece di quello sottile. */
  marcata?: boolean;
  rilievo?: boolean;
  /** Senza spaziatura interna: per schede che contengono una tabella o un elenco. */
  piatta?: boolean;
  children: ReactNode;
}

export function Scheda({
  titolo,
  accanto,
  marcata = false,
  rilievo = false,
  piatta = false,
  className,
  children,
  ...resto
}: Props) {
  const classi = [
    'scheda',
    marcata && 'scheda--marcata',
    rilievo && 'scheda--rilievo',
    piatta && 'scheda--piatta',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classi} {...resto}>
      {titolo ? (
        <div className="scheda__intestazione">
          <div className="scheda__titolo">{titolo}</div>
          {accanto}
        </div>
      ) : null}
      {children}
    </div>
  );
}
